'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenEnquiriesController = function () {
  function OpenEnquiriesController(authService, userService, loadingService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, OpenEnquiriesController);
    this.authService = authService;
    this.userService = userService;
    this.loadingService = loadingService;

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };

    this.overrideUserId = null;
    this.enquiries = [];

    $scope.$on('dashboard:viewOpenEnquiriesStats', this.loadStats.bind(this));
    $scope.$on('dashboard:viewOpenEnquiries', this.viewOpenEnquiries.bind(this));
  }

  (0, _createClass3.default)(OpenEnquiriesController, [{
    key: 'loadStats',
    value: function loadStats(evt, params) {
      var ctrl = this;

      ctrl.loadingService.showLoading('enquiryList', 'Loading Enquiries');

      this.overrideUserId = params ? params.userId : null;

      ctrl.userService.openEnquiriesStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId).then(function (response) {
        ctrl.pagination.totalItems = response.data;
        ctrl.onLoadStats({ count: response.data });
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquiryList');
      });
    }
  }, {
    key: 'viewOpenEnquiries',
    value: function viewOpenEnquiries(evt, params) {
      //Toggle Event coming from dashboard instead of page change, skip the method
      if (evt && this.enquiries.length && !params.reload) {
        return;
      }

      var ctrl = this;

      ctrl.loadingService.showLoading('enquiryList', 'Loading Enquiries');

      ctrl.userService.openEnquiries(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.pagination.currentPage).then(function (response) {
        ctrl.enquiries = response.data;
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquiryList');
      });
    }
  }]);
  return OpenEnquiriesController;
}();

exports.default = OpenEnquiriesController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/openEnquiries/openEnquiries.controller.js